export default {
  env: 'prod'
}